export default {
  env: 'prod'
}